import React, { FC } from "react";
import { Bold, Paragraph } from "../../../typography";

/**
 * The `HighlightedMatches` component properties.
 */
interface HighlightedMatchesProps {
   /**
   * The label shown to represent the result option.
   */
   readonly text: string;

   /**
   * The value used for matching against the user's input.
   */
   readonly query: string;
}

/**
 * The a component to display typeahead feature on a search.
 */
export const HighlightedMatches: FC<HighlightedMatchesProps> = (props) => {
  const { text, query } = props;
  if (!query) return <>{text}</>;

  const formatted: JSX.Element[] = [];

  const re = new RegExp(String.raw`${query}`, "gi");
  const matches = text.matchAll(re);


  let currentIndex = 0;
  for (const match of matches) {
    const endIndex = match.index + match[0].length;

    const plainText = text.slice(currentIndex, match.index);
    const highlightText = text.slice(match.index, endIndex);

    const plainKey = `${currentIndex}_${match.index}`;
    const highlightKey = `${match.index}_${endIndex}`;

    formatted.push(
      <React.Fragment key={plainKey}>{plainText}</React.Fragment>,
      <Bold key={highlightKey}>{highlightText}</Bold>,
    );

    currentIndex = endIndex;
  }

  formatted.push(
    <React.Fragment key={`${currentIndex}_${text.length}`}>
      {text.substring(currentIndex)}
    </React.Fragment>,
  );

  return (
    <Paragraph>
      {formatted}
    </Paragraph>
  );
};
